module.exports = "/_next/static/images/harajuku_late_lunch-74fb22c439630aa8c80001db5c1237f0.jpg";